// const config = require('../../config')
// const RUTA_GLOBAL = process.env.NODE_ENV === 'production'
// ? config.build.API_URL
// : config.dev.API_URL
// // const RUTA_GLOBAL = "http://localhost/sistema-gimnasio-main/api/"
// const HttpService = {
//     async registrar(datos, ruta){
//         const respuesta = await fetch(RUTA_GLOBAL + ruta, {
//             method: "post",
//             body: JSON.stringify(datos),
//         });
//         let resultado = await respuesta.json()
//         return resultado
//     },

//     async obtenerConDatos(datos, ruta){
//         const respuesta = await fetch(RUTA_GLOBAL + ruta, {
//             method: "post",
//             body: JSON.stringify(datos),
//         });
//         let resultado = await respuesta.json()
//         return resultado
//     },


//     async obtener(ruta){
//         let respuesta = await fetch(RUTA_GLOBAL + ruta)
//         let datos = await respuesta.json()
//         return datos
//     },

//     async eliminar(ruta, datos) {
//         const respuesta = await fetch(RUTA_GLOBAL + ruta, {
//             method: "post",
//             body: JSON.stringify(datos),
//         });
//         let resultado = await respuesta.json()
//         return resultado
//     }

// }

// export default  HttpService



// HttpService.js
import apiFetch from './ApiProxy';

const HttpService = {
    async registrar(datos, ruta) {
        return apiFetch(ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
    },

    async obtenerConDatos(datos, ruta) {
        return apiFetch(ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
    },

    async obtener(ruta) {
        return apiFetch(ruta);
    },

    async eliminar(ruta, datos) {
        return apiFetch(ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
    }
}

export default HttpService;
